import { Pill } from '@99designs/common/components/Pill';
import React from 'react';

const PillContainer: React.FunctionComponent<{ title?: string; items: string[] }> = ({
    title,
    items,
}) => (
    <div className="pill-container">
        {title && <div className="pill-container__title">{title}</div>}
        <div className="pill-container__pills">
            {items.map(item => (
                <Pill key={item}>{item}</Pill>
            ))}
        </div>
    </div>
);

export default PillContainer;
